export default __webpack_public_path__ + "static/media/djamo.cee22dcb.png";